import { Injectable } from '@angular/core';
import { HttpInterceptor } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpHandler } from '@angular/common/http';
import { HttpEvent } from '@angular/common/http';
import { TokenServiceService } from './token-service.service';

@Injectable()
export class InterceptorService implements HttpInterceptor {
    token: string;
    state: string;
    route: string;
    constructor(private tokenService: TokenServiceService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.tokenService.selectedstateCode.subscribe(token => {
            this.token = token
            console.log(this.token)
        })
        this.token = sessionStorage.getItem('wEnlw3OeU3')
        this.route = sessionStorage.getItem('rtItemPath')

        // Clone request with withCredentials so browser accepts and sends cookies
        req = req.clone({ withCredentials: true });

        if (this.token) {
            if(this.route == "axdcmqihn"){
                console.log(this.token)
                const tokenizedReq = req.clone({ headers: req.headers.set('route-api-key', this.token).set('fr-re-token-api-route','rx9U2r9MOQYqMNbuew1ARfmxinKfakBa').set('source-api-key','WsIjB6vsrdYYl615c1EarEG48d8n1CSx').set('res-fresh-token','F4F8875DD58AD') })
                // const tokenizedReq = req.clone({ headers: req.headers.set('route-api-key', "KDw2nS6vb5cJ286KJ3JwtGKGnnnLO93Y").set('fr-re-token-api-route','rx9U2r9MOQYqMNbuew1ARfmxinKfakBa') });
                return next.handle(tokenizedReq);
            }else if(this.route == "ftrwrefsh"){
                console.log(this.token)
                const tokenizedReq = req.clone({ headers: req.headers.set('route-api-key', this.token).set('fr-re-token-api-route','fEX2MF2z6zLvvWDu9t1JSLVhKxqiRIqv').set('source-api-key','WsIjB6vsrdYYl615c1EarEG48d8n1CSx').set('res-fresh-token','F4F8875DD58AD')});
                return next.handle(tokenizedReq);
            }

        }

        return next.handle(req);
    }
}